<template>
    <section class="work-list">
        <router-link 
            v-for="work in works"
            :key="work.id"
            class="work-list-item"
            :to="{name: 'player', params: {slug: work.slug}}"
            :data-slug="work.slug"
        >
            <div :class="['work-list-item-label', {
                'is-dark': work.text_is_dark
            }]">
                <h3 class="work-list-item-label-primary">{{ work.primary }}</h3>
                <h4 class="work-list-item-label-secondary">{{ work.secondary }}</h4>
            </div>
            <img :src="work.src" alt="">
        </router-link>
    </section>
</template>

<script>

// Data
export default {
    props: {
        works: {
            type: Array,
            required: true,
        },
    },
    name: "WorkListMobile",
}
</script>

<style lang="scss" scoped>
    .work-list{
        &-item{
            position: relative;
            height: (9/16) * 100vw;
            display: block;

            &-label{
                position: absolute;
                bottom: 0;
                left: 0;
                width: 100%;
                padding-left: 33px;
                padding-bottom: 33px;

                @include very-small{
                    padding-left: 20px;
                    padding-bottom: 11px;
                }

                &.is-dark{
                    // color: $black;
                }
                
                &-primary, &-secondary{
                    font-family: $font-title;
                    line-height: ptToPx(28);
                    font-size: ptToPx(24);
                    text-transform: uppercase;
                    display: inline-block;

                    @include very-small{
                        font-size: ptToPx(14);
                    }
                }

                &-primary{
                    margin-right: 6px;
                    font-weight: 700;
                }

                &-secondary{
                    font-weight: 200;
                }
            }

            img{
                display: block;
                width: 100%;
                height: 100%;
                object-fit: cover;
                object-position: center;
            }
        }
    }
</style>